import React, { useContext, useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { ActionLink, Button } from '../../atoms';
import { UserContext, ToasterContext } from '../../../context';

import { default as t } from '../../../utils/i18n';
import config from '../../../utils/config';
import { ReactComponent as OptimizeImg } from '../../../assets/svg/optimise.svg';
import { ReactComponent as ReportImg } from '../../../assets/svg/report.svg';
import { ReactComponent as PieImg } from '../../../assets/svg/pie.svg';
import './interstitial-layout.scss';
import { Popover, Whisper, Dropdown } from 'rsuite';
import { ReactComponent as KebabIcon } from '../../../assets/svg/kebab.svg';

const HELP_SUPPORT_LINK = config.get('help', 'support_link');
const HELP_EMAIL_ID = config.get('help', 'support_email');
const HELP_LINK = config.get('help', 'support_url');
function Interstitialayout() {
  const { message, setMessage } = useContext(ToasterContext);
  const { user, setUser } = useContext(UserContext);
  const history = useHistory();
  const whisperRef1 = useRef(null);
  const menuItems = [
    { id: 1, itemName: t('admin.menu.manage.accounts') },
    { id: 5, itemName: t('BLS Insights') },
    { id: 6, itemName: 'Upload Catalog PDF' },
    { id: 2, itemName: t('admin.menu.contact.us') },
    // { id: 3, itemName: t('admin.menu.notification.manager') },
    { id: 4, itemName: t('dashboard.nav.header.link.signOut') },
  ];

  const findbusinessInsights = async e => {
    e.preventDefault();

    try {
      let stateObject = {
        ...user,
        insights: true,
      };
      localStorage.setItem('user', JSON.stringify(stateObject));
      setUser(stateObject);
      history.push('/');
    } catch (error) {}
  };

  const performanceOpt = async e => {
    e.preventDefault();

    try {
      let stateObject = {
        ...user,
        insights: true,
      };
      localStorage.setItem('user', JSON.stringify(stateObject));
      setUser(stateObject);
      history.push('/optimization');
    } catch (error) {}
  };

  useEffect(() => {
    if (!user?.trackingIds) {
      const stored = localStorage.getItem('user');
      if (stored) {
        setUser(JSON.parse(stored));
      }
      return;
    }
    setMessage({});
    setUser(prevUser => ({
      ...prevUser,
      selectedAdaccounts: '',
      selectedAdvertiser: '',
      isSaveDraft: false,
    }));
  }, []);

  const reportsOpt = async e => {
    e.preventDefault();

    try {
      history.push('/reports');
    } catch (error) {}
  };

  const handleSelect = item => {
    switch (item.id) {
      case 1:
        history.push('/manage-accounts');
        break;

      case 2:
        window.open(`${HELP_LINK}`, '_blank');
        break;

      case 3:
        history.push('/link-accounts');
        break;

      case 4:
        history.push('/signOut');
        break;

      case 5:
        history.push('/bls_insights');
        break;
      case 6:
        history.push('/add-catalog-pdf');
        break;
    }
    whisperRef1.current.close();
  };

  return (
    <div className="interstitial-container">
      <div className="interstitial__heading">
        <div className="interstitial__userdetails">
          <p>
            {t('signup.step2.heading')}{' '}
            <span className="interstitial__heading-username">{user?.name}</span>
          </p>
          <p className="interstitial__heading-email">({user?.username})</p>
        </div>
        <div className="interstitial__support">
          {/* <a className="c-business--label-bold logout" href="/signOut">
            {t('dashboard.nav.header.link.signOut')}
          </a> */}
          <div className="interstitial__support-policy">
            <ActionLink
              anchor={true}
              href={HELP_SUPPORT_LINK.replace(
                /\{(.*?)\}/gi,
                t('dashboard.link.helpAndSupport', true)
              )}
              value={t('dashboard.link.helpAndSupport')}
              icon={true}
            />
            {/* <ActionLink
              anchor={true}
              href={HELP_LINK}
              value={t('dashboard.link.emailus')}
              icon={true}
            ></ActionLink> */}
          </div>
        </div>
        <div className="interstitial_dropdown">
          <Whisper
            ref={whisperRef1}
            placement="auto"
            trigger="click"
            speaker={
              <Popover>
                <Dropdown.Menu onSelect={handleSelect}>
                  {menuItems?.map((item, index) => {
                    return (!['SUPERADMIN', 'ADMIN'].includes(user?.role) && index) === 0 ? (
                      ''
                    ) : (
                      <Dropdown.Item eventKey={item}>{item.itemName}</Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Popover>
            }
          >
            <KebabIcon />
          </Whisper>
        </div>
      </div>
      <div className="interstitial__details-insight">
        <div className="interstitial__details__insightdetails">
          <p className="interstitial__details__insightdetails-heading">
            {t('interstitial.insight.heading')}
          </p>
          <p className="interstitial__details__insightdetails-subheading">
            {t('interstitial.insight.subheading')}
          </p>
          <Button
            type="button"
            label={t('interstitial.insight.button.label')}
            handleClick={findbusinessInsights}
          ></Button>
        </div>
        <OptimizeImg className="interstitial__details__insightimg" />
      </div>
      <div className="interstitial__details-reports">
        <div className="interstitial__details__optimizedetails">
          <p className="interstitial__details__optimizedetails-heading">
            {t('interstitial.optimize.heading')}
          </p>
          <p className="interstitial__details__optimizedetails-subheading">
            {t('interstitial.optimize.subheading')}
          </p>
          <PieImg className="interstitial__details__optimizeimg" />
          <Button
            className="performance-opt"
            type="button"
            label={t('performance.insights')}
            handleClick={performanceOpt}
          ></Button>
        </div>
        <div className="interstitial__details__reportdetails">
          {/* <span className="interstitial__details-comingsoon">
            {t('interstitial.comingsoon.label')}
          </span> */}
          <p className="interstitial__details__reportdetails-heading">
            {t('interstitial.report.heading')}
          </p>
          <p className="interstitial__details__reportdetails-subheading">
            {t('interstitial.report.subheading')}
          </p>
          <ReportImg className="interstitial__details__reportimg Generate-img-height" />
          <Button
            className="performance-opt g-btn-top"
            type="button"
            label={t('generate.reports')}
            handleClick={reportsOpt}
          ></Button>
        </div>
      </div>
    </div>
  );
}

export default Interstitialayout;
